class Sticky {
  constructor() {
    this.el = document.getElementById("jsSticky");
    this.timer = 100;
    this.timeout = null;
    this.className = "sticky";
    this.effects = ["fadeInRight", "slideInDown"];
    this.stickyIcon = document.getElementById("jsStickyIcon");
    this.stickyInfo = document.getElementById("jsStickyInfo");
    this.stickyIconSpan = null;
    this.iconIndex = 0;
    this.Init();
    this.Click();
    this.Scroll();
  }

  Click() {
    if (this.stickyIcon) {
      this.stickyIcon.addEventListener("click", (e) => {
        this.stickyIcon.parentElement.classList.toggle("active");
        this.stickyInfo.classList.toggle("zoomOut");
        this.stickyInfo.classList.toggle("zoomIn");
        e.preventDefault();
      });
    }
  }

  Init() {
    if (this.el) {
      if (window.scrollY >= 100) {
        this.el.classList.add(this.className);
      } else {
        this.el.classList.remove(this.className);
      }
    }
    if (this.stickyIcon) {
      this.stickyIconSpan = this.stickyIcon.querySelectorAll("span");
      if (this.stickyIconSpan) {
        this.Animation();
      }
    }
  }

  Scroll() {
    window.addEventListener("scroll", () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.Init(), this.timer);
    });
  }

  Animation() {
    this.stickyIconSpan.forEach((el) => {
      el.classList.remove(...this.effects);
    });
    this.stickyIconSpan[this.iconIndex].classList.add(
      this.effects[Math.floor(Math.random() * this.effects.length)]
    );
  }
}

window.addEventListener("load", () => {
  let sticky = new Sticky();
  setInterval(function () {
    sticky.Animation();
    sticky.iconIndex++;
    if (sticky.iconIndex >= sticky.stickyIconSpan.length) {
      sticky.iconIndex = 0;
    }
  }, 1000);
});
